import {Component, Input, OnInit} from '@angular/core';
import {FieldsInterventionsPageRequest} from '../fields-interventions-page/fields-interventions-page-request';

@Component({
  selector: 'app-fields-interventions-settings',
  templateUrl: './fields-interventions-settings.component.html',
  styleUrls: ['./fields-interventions-settings.component.scss']
})
export class FieldsInterventionsSettingsComponent implements OnInit {

  @Input()
  request: FieldsInterventionsPageRequest;

  @Input()
  width: number;

  @Input()
  height: number;

  @Input()
  visible: boolean;

  constructor() {
  }

  ngOnInit(): void {
  }

}
